import React from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

interface ExternalRoastDialogProps {
  onClose: () => void
  onAddExternalRoast: (externalRoastName: string) => void
}

const ExternalRoastDialog = (props: ExternalRoastDialogProps): JSX.Element => {
  const { t } = useTranslation()
  const [externalRoastName, setExternalRoastName] = React.useState<string>('')

  return (
    <Dialog open={true} onClose={props.onClose}>
      <DialogTitle>{t('cupping.addexternalsample')}</DialogTitle>
      <DialogContent>
        <TextField
          sx={{ mt: 1 }}
          label={t('cupping.externalsamplename')}
          fullWidth
          value={externalRoastName}
          inputProps={{ maxLength: 255 }}
          onChange={(event) => setExternalRoastName(event.target.value)}
          onKeyPress={(event): void => {
            if (event.key === 'Enter') {
              props.onAddExternalRoast(externalRoastName)
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>{t('common.cancel')}</Button>
        <Button
          variant="contained"
          disabled={!externalRoastName.trim()}
          onClick={() => props.onAddExternalRoast(externalRoastName.trim())}
        >
          {t('cupping.addexternalsample')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExternalRoastDialog
